import type { PrototypeCatalogEntity } from "../../entity_types/catalog";

export const catalog_audreys_home_gift: PrototypeCatalogEntity = {
  token: "catalog_audreys_home_gift",
  type: "catalog",
  name: "Audrey's Home & Gift Catalog",
  brandToken: "catalog_brand_audreys_home_gift",
  collectionTokens: [
    "col_bestsellers",
    "col_previously-ordered",
    "col_confetti-cake",
    "col_pattern-play",
    "col_japandi",
    "col_andean-touch",
    "col_camp",
    "col_vintage-holiday",
    "col_winter-folklore",
    "col_heritage-holiday",
    "col_palm-pine",
    "col_japandi-christmas",
    "col_fireside-fall",
    "col_vintage-halloween",
    "col_spooktacular",
    "col_cabinet-curiosities",
    "col_home-accents",
    "col_kitchen-tabletop",
    "col_textile-pillows",
    "col_candles-holders",
  ],
  categoryTokens: [
    "catalog_cat_home-accents",
    "catalog_cat_kitchen-tabletop",
    "catalog_cat_wall-decor",
    "catalog_cat_throw-pillows",
    "catalog_cat_garden-outdoor",
    "catalog_cat_candles-holders",
    "catalog_cat_storage-organization",
    "catalog_cat_household-diy",
    "catalog_cat_bath",
    "catalog_cat_home-fragrances",
    "catalog_cat_party-supplies",
    "catalog_cat_stationery-writing",
    "catalog_cat_gift-wrapping",
    "catalog_cat_crafts-hobbies",
    "catalog_cat_games-puzzles",
    "catalog_cat_stickers-pins",
    "catalog_cat_womens-accessories",
    "catalog_cat_mens-accessories",
    "catalog_cat_jewelry-storage",
    "catalog_cat_coffee-tea",
    "catalog_cat_makeup",
    "catalog_cat_bath-body",
    "catalog_cat_dogs",
    "catalog_cat_cats",
    "catalog_cat_book-accessories",
  ],
  productTokens: [
    "catalog_prod_prod-1",
    "catalog_prod_prod-2",
    "catalog_prod_prod-3",
    "catalog_prod_prod-4",
    "catalog_prod_prod-5",
    "catalog_prod_prod-6",
    "catalog_prod_prod-7",
    "catalog_prod_prod-8",
    "catalog_prod_prod-9",
    "catalog_prod_prod-10",
    "catalog_prod_prod-11",
    "catalog_prod_prod-12",
    "catalog_prod_prod-13",
    "catalog_prod_prod-14",
    "catalog_prod_prod-15",
    "catalog_prod_prod-16",
    "catalog_prod_prod-17",
    "catalog_prod_prod-18",
    "catalog_prod_prod-19",
    "catalog_prod_prod-20",
    "catalog_prod_prod-21",
    "catalog_prod_prod-22",
    "catalog_prod_prod-23",
    "catalog_prod_prod-24",
    "catalog_prod_prod-25",
    "catalog_prod_prod-26",
    "catalog_prod_prod-27",
    "catalog_prod_prod-28",
    "catalog_prod_prod-29",
    "catalog_prod_prod-30",
    "catalog_prod_prod-31",
    "catalog_prod_prod-32",
    "catalog_prod_prod-33",
    "catalog_prod_prod-34",
    "catalog_prod_prod-35",
    "catalog_prod_prod-36",
    "catalog_prod_prod-37",
    "catalog_prod_prod-38",
    "catalog_prod_prod-39",
    "catalog_prod_prod-40",
    "catalog_prod_prod-41",
    "catalog_prod_prod-42",
    "catalog_prod_prod-43",
    "catalog_prod_prod-44",
    "catalog_prod_prod-45",
    "catalog_prod_prod-46",
    "catalog_prod_prod-47",
    "catalog_prod_prod-48",
    "catalog_prod_prod-49",
    "catalog_prod_prod-50",
    "catalog_prod_prod-51",
    "catalog_prod_prod-52",
    "catalog_prod_prod-53",
    "catalog_prod_prod-54",
    "catalog_prod_prod-55",
    "catalog_prod_prod-56",
    "catalog_prod_prod-57",
    "catalog_prod_prod-58",
    "catalog_prod_prod-59",
    "catalog_prod_prod-60",
    "catalog_prod_prod-61",
    "catalog_prod_prod-62",
    "catalog_prod_prod-63",
    "catalog_prod_prod-64",
    "catalog_prod_prod-65",
    "catalog_prod_prod-66",
    "catalog_prod_prod-67",
    "catalog_prod_prod-68",
    "catalog_prod_prod-69",
    "catalog_prod_prod-70",
    "catalog_prod_prod-71",
    "catalog_prod_prod-72",
    "catalog_prod_prod-73",
    "catalog_prod_prod-74",
    "catalog_prod_prod-75",
    "catalog_prod_prod-76",
    "catalog_prod_prod-77",
    "catalog_prod_prod-78",
    "catalog_prod_prod-79",
    "catalog_prod_prod-80",
    "catalog_prod_prod-81",
    "catalog_prod_prod-82",
    "catalog_prod_prod-83",
    "catalog_prod_prod-84",
    "catalog_prod_prod-85",
    "catalog_prod_prod-86",
    "catalog_prod_prod-87",
    "catalog_prod_prod-88",
    "catalog_prod_prod-89",
    "catalog_prod_prod-90",
    "catalog_prod_prod-91",
    "catalog_prod_prod-92",
    "catalog_prod_prod-93",
    "catalog_prod_prod-94",
    "catalog_prod_prod-95",
    "catalog_prod_prod-96",
    "catalog_prod_prod-97",
    "catalog_prod_prod-98",
    "catalog_prod_prod-99",
    "catalog_prod_prod-100",
    "catalog_prod_prod-101",
    "catalog_prod_prod-102",
    "catalog_prod_prod-103",
    "catalog_prod_prod-104",
    "catalog_prod_prod-105",
    "catalog_prod_prod-106",
    "catalog_prod_prod-107",
    "catalog_prod_prod-108",
    "catalog_prod_prod-109",
    "catalog_prod_prod-110",
    "catalog_prod_prod-111",
    "catalog_prod_prod-112",
    "catalog_prod_prod-113",
    "catalog_prod_prod-114",
    "catalog_prod_prod-115",
    "catalog_prod_prod-116",
    "catalog_prod_prod-117",
    "catalog_prod_prod-118",
    "catalog_prod_prod-119",
    "catalog_prod_prod-120",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
